/**
 * Risk-flag colour — every AI risk flag renders in the one theme-aware
 * destructive red, whatever severity word the model emitted: each is a risk.
 * Declared once so the flag chip and the plain risk pill can never drift
 * apart. Written out whole, not built from parts: Tailwind finds classes by
 * scanning source text.
 */
export const RISK_TEXT_CLASS = 'text-destructive';
export const RISK_BG_CLASS = 'bg-destructive/12';
export const RISK_RULE_CLASS = 'bg-destructive';
